import { render } from "./custom.vue?vue&type=template&id=3868689c"
import script from "./custom.vue?vue&type=script&lang=js"
export * from "./custom.vue?vue&type=script&lang=js"

import "./custom.vue?vue&type=style&index=0&id=3868689c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__